(function () {
    'use strict';

    angular
        .module('app.book')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion', 'config'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion, config) {
        routerHelper.configureStates(getStates(opsIncludeVersion, config.apiTypes));
    }

    function getStates(opsIncludeVersion, apiTypes) {
        return [
             {
                 state: 'book',
                 config: {
                     url: '/book',
                     templateUrl: 'app/book/book.html?v=' + opsIncludeVersion,
                     controller: 'BookController',
                     controllerAs: 'vm',
                     title: 'Book',
                     settings: {
                         nav: 250,
                         content: '<i class="fa fa-book "></i> <span class="leftNavText">Book</span>',
                         badgeContent: '',
                         authMode: 1,
                         requireOps: true,
                         requireDataApi: true,
                         mobileButton: true
                     },
                     resolve: {
                         authenticationRequired: ['userService', function (userService) {
                             userService.isAuthenticatedThrowError();
                         }]
                     }
                 }
             },
           
           
        ];
    }
})();
